// components
import AttributeInput from '../../../components/components/atoms/AttributeInput/AttributeInput';
import {Modal, Row, Column, Button, Switch, Table} from '@drivesally/sally-ui';

// layout
import ModalLoader from '../../../layout/components/ModalLoader/ModalLoader';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Fragment} from 'react';

// types
import {amount as amountType} from '@drivesally/sally-fn/lib/types';

const columns = [
  {key: 'name', label: 'Name'},
  {key: 'desc', label: 'Description'},
  {key: 'rate', label: 'Rate'},
  {key: 'deductible_amount', label: 'Deductible Amount'},
  {key: 'default', label: 'Default'},
  {key: 'actions', label: ''},
];

const formatAmount = (value) => {
  if (value == null || value === '') return '—';
  return `$${amountType(value).format()}`;
};

const BranchReducedDeductibleModal = ({
  branch,
  cancelEdit,
  changeEdit,
  changeNew,
  createRate,
  deleteRate,
  deletingId,
  editDeductible_amount,
  editDefault,
  editDesc,
  editName,
  editRate,
  editingId,
  loading,
  newDefault,
  newDeductible_amount,
  newDesc,
  newName,
  newRate,
  onClose,
  rates,
  saveEdit,
  savingCreate,
  savingUpdateId,
  startEdit,
  toggleDefault,
  togglingDefaultId,
  visible,
}) => {
  const busy =
    !!savingCreate ||
    !!savingUpdateId ||
    deletingId !== null ||
    togglingDefaultId !== null;

  return (
    <Modal
      title="Insurance Packages"
      subtitle={branch?.name ? branch.name : ''}
      visible={visible}
      onClose={onClose}
      size="large"
    >
      {(Content) => (
        <Fragment>
          <Content padding="none" noBorder>
            {loading ? (
              <ModalLoader />
            ) : (
              <Table columns={columns} noBorder noRadius smallNoResultsLabel>
                {(TableRow) =>
                  rates.map((rate) => {
                    const isEditing = editingId === rate.id;
                    const rowBusy =
                      savingUpdateId === rate.id || deletingId === rate.id;
                    return (
                      <TableRow key={rate.id}>
                        {(TableCol) => [
                          <TableCol key="name">
                            {isEditing ? (
                              <AttributeInput
                                value={editName}
                                onChange={changeEdit}
                                disabled={rowBusy}
                              >
                                {editName.label.default}
                              </AttributeInput>
                            ) : (
                              rate.name || '—'
                            )}
                          </TableCol>,
                          <TableCol key="desc">
                            {isEditing ? (
                              <AttributeInput
                                value={editDesc}
                                onChange={changeEdit}
                                disabled={rowBusy}
                              >
                                {editDesc.label.default}
                              </AttributeInput>
                            ) : (
                              rate.desc || '—'
                            )}
                          </TableCol>,
                          <TableCol key="rate">
                            {isEditing ? (
                              <AttributeInput
                                value={editRate}
                                onChange={changeEdit}
                                disabled={rowBusy}
                              >
                                {editRate.label.default}
                              </AttributeInput>
                            ) : (
                              formatAmount(rate.rate)
                            )}
                          </TableCol>,
                          <TableCol key="deductible_amount">
                            {isEditing ? (
                              <AttributeInput
                                value={editDeductible_amount}
                                onChange={changeEdit}
                                disabled={rowBusy}
                              >
                                {editDeductible_amount.label.default}
                              </AttributeInput>
                            ) : (
                              formatAmount(rate.deductible_amount)
                            )}
                          </TableCol>,
                          <TableCol key="default">
                            {isEditing ? (
                              <AttributeInput
                                value={editDefault}
                                onChange={changeEdit}
                                disabled={rowBusy}
                              >
                                {editDefault.label.default}
                              </AttributeInput>
                            ) : (
                              <Switch
                                value={!!rate.default}
                                disabled={
                                  rowBusy ||
                                  busy ||
                                  editingId !== null
                                }
                                onChange={(checked) =>
                                  toggleDefault(rate, checked)
                                }
                              />
                            )}
                          </TableCol>,
                          <TableCol key="actions" align="right">
                            {isEditing ? (
                              <Fragment>
                                <Button
                                  size="small"
                                  onClick={saveEdit}
                                  loading={savingUpdateId === rate.id}
                                  disabled={
                                    deletingId !== null &&
                                    deletingId !== rate.id
                                  }
                                >
                                  Save
                                </Button>
                                <Button
                                  size="small"
                                  theme="grey"
                                  onClick={cancelEdit}
                                  disabled={rowBusy}
                                >
                                  Cancel
                                </Button>
                              </Fragment>
                            ) : (
                              <Fragment>
                                <Button
                                  size="small"
                                  theme="grey"
                                  icon="edit"
                                  onClick={() => startEdit(rate)}
                                  disabled={busy || editingId !== null}
                                />
                                <Button
                                  size="small"
                                  theme="grey"
                                  icon="delete"
                                  onClick={() => deleteRate(rate.id)}
                                  loading={deletingId === rate.id}
                                  disabled={
                                    busy ||
                                    (editingId !== null &&
                                      editingId !== rate.id)
                                  }
                                />
                              </Fragment>
                            )}
                          </TableCol>,
                        ]}
                      </TableRow>
                    );
                  })
                }
              </Table>
            )}
          </Content>
          <Content>
            <Row margin>
              <Column size={1 / 4}>
                <AttributeInput
                  value={newName}
                  onChange={changeNew}
                  disabled={busy || loading || editingId !== null}
                >
                  {newName.label.default}
                </AttributeInput>
              </Column>
              <Column size={1 / 4}>
                <AttributeInput
                  value={newDesc}
                  onChange={changeNew}
                  disabled={busy || loading || editingId !== null}
                >
                  {newDesc.label.default}
                </AttributeInput>
              </Column>
              <Column size={1 / 6}>
                <AttributeInput
                  value={newRate}
                  onChange={changeNew}
                  disabled={busy || loading || editingId !== null}
                >
                  {newRate.label.default}
                </AttributeInput>
              </Column>
              <Column size={1 / 6}>
                <AttributeInput
                  value={newDeductible_amount}
                  onChange={changeNew}
                  disabled={busy || loading || editingId !== null}
                >
                  {newDeductible_amount.label.default}
                </AttributeInput>
              </Column>
              <Column size={1 / 6}>
                <AttributeInput
                  value={newDefault}
                  onChange={changeNew}
                  disabled={busy || loading || editingId !== null}
                >
                  {newDefault.label.default}
                </AttributeInput>
              </Column>
              <Column size={1 / 6}>
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-end',
                  }}
                >
                  <Button
                    onClick={createRate}
                    loading={savingCreate}
                    disabled={busy || loading || editingId !== null}
                  >
                    Add Package
                  </Button>
                </div>
              </Column>
            </Row>
          </Content>
        </Fragment>
      )}
    </Modal>
  );
};

BranchReducedDeductibleModal.propTypes = {
  branch: PropTypes.object,
  cancelEdit: PropTypes.func,
  changeEdit: PropTypes.func,
  changeNew: PropTypes.func,
  createRate: PropTypes.func,
  deleteRate: PropTypes.func,
  deletingId: PropTypes.any,
  editDeductible_amount: PropTypes.object,
  editDefault: PropTypes.object,
  editDesc: PropTypes.object,
  editName: PropTypes.object,
  editRate: PropTypes.object,
  editingId: PropTypes.any,
  loading: PropTypes.bool,
  newDefault: PropTypes.object,
  newDeductible_amount: PropTypes.object,
  newDesc: PropTypes.object,
  newName: PropTypes.object,
  newRate: PropTypes.object,
  onClose: PropTypes.func,
  rates: PropTypes.array,
  saveEdit: PropTypes.func,
  savingCreate: PropTypes.bool,
  savingUpdateId: PropTypes.any,
  startEdit: PropTypes.func,
  toggleDefault: PropTypes.func,
  togglingDefaultId: PropTypes.any,
  visible: PropTypes.bool,
};

export default BranchReducedDeductibleModal;
